module.exports = __webpack_public_path__ + "img/Default-M-16.83518092.svg";